// import { Auth } from 'aws-amplify';
import Vue from 'vue';
import router from '@/router';
import LocalStorageService from '@/core/services/localStorage.service';

const state = () => ({
  loading: false,
  isAuthenticated: false,
  error: ''
});

const getters = {};

const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },

  setIsAuthenticated(state, isAuthenticated) {
    state.isAuthenticated = isAuthenticated;
  },

  setError(state, error) {
    state.error = error;
  }
};

const actions = {
  authenticateSuccess({ commit }) {
    Vue.prototype.$api.data.setHeader(LocalStorageService.getToken());
    commit('setIsAuthenticated', true);
  },
  authenticateFail({ commit }, message) {
    LocalStorageService.destroy();
    commit('setIsAuthenticated', false);
    commit('setError', message);
  },
  async signIn({ commit, dispatch }, { username, password }) {
    commit('setLoading', true);
    commit('setError', '');
    try {
      const {
        data: { access_token, expires_in }
      } = await Vue.prototype.$api.auth.getToken(username, password);
      LocalStorageService.saveToken(access_token);
      LocalStorageService.saveExpiresAt(new Date().getTime() + expires_in * 1000);
      dispatch('authenticateSuccess');
      if (router.currentRoute.path === '/login') {
        await router.push('/').catch((e) => console.warn(e));
      }
      return true;
    } catch (e) {
      console.log(e);
      const errorMessage = e.response?.data?.message || 'Invalid credentials';
      dispatch('authenticateFail', errorMessage);
      return false;
    } finally {
      commit('setLoading', false);
    }
  },
  async autoSignIn({ commit, dispatch }) {
    commit('setLoading', true);
    try {
      const expiresAt = LocalStorageService.getExpiresAt();
      const accessToken = LocalStorageService.getToken();

      if (expiresAt && new Date() > expiresAt) {
        LocalStorageService.destroy();
        commit('setIsAuthenticated', false);
        return false;
      } else if (accessToken) {
        dispatch('authenticateSuccess');
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      commit('setLoading', false);
    }
  },
  async signOut({ commit }) {
    LocalStorageService.destroy();
    commit('setIsAuthenticated', false);
    await router.push('/login').catch((e) => console.warn(e));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
